var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenBox"},[_c('div',{staticClass:"describe"},[_c('div',{staticClass:"top"},[_c('div',[_vm._v(_vm._s(_vm.enterName))])]),_c('div',{staticClass:"bottom"},[_c('div',[_vm._v("登录于："+_vm._s(this.currentTime))]),(_vm.flag)?_c('div',{on:{"click":_vm.edit}},[_vm._v("编辑")]):_vm._e()])]),_c('div',{class:_vm.flag ? 'logo' : 'logo2'})])
}
var staticRenderFns = []

export { render, staticRenderFns }